import React from "react";
import { SyntheticEvent } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./PropertyThumbnail.css";
import { ReactComponent as CheckboxSVG } from "./checkbox.svg";
import { ReactComponent as UnCheckboxSVG } from "./unchecked.svg";
//import properties from "./properties.json";
import {  PropertyImage, SortMode, DisplayMode } from "./types";
import { dd, formatPrice, toS3Image, formatDecimalNumber } from "./Utils";
import { hideShareableLink } from "./InvalidateShareLink";
import { PropertyAPI } from "./lib/property-api";
import { SavedRow, } from "./types";
import { PropertySource } from "./lib/property-api";
function processPostalCity(d: string|null) : string {
  if(d === null || String(d).length === 0){
    return '';
  }
  d = d.replace(/^[\s]+/,'').replace(/[\s]+$/,'');
  return [String(d[0]).toUpperCase(),d.slice(1)].join('');
}

function presentUnitNumber(unitNumber: string|null) : string {
  if(unitNumber === null){
    return '';
  }
  if(typeof unitNumber === 'string'){
    if(unitNumber.match(/^#/)){
      return `Unit ${unitNumber}`;
    }
    if(unitNumber.length > 0){
      return `Unit #${unitNumber}`;
    }
  }
  return '';
}
interface Props {
  property_id: string;
  sort_mode: SortMode;
  display_mode: DisplayMode;
  remove_from_url?: string[];
  show_share_property_icons: boolean;
  source: PropertySource;
}
const EMPTY_PROFILE_IMAGE: string =
  "https://lombardo.nyc3.digitaloceanspaces.com/mls/no-img.png";

function PropertyThumbnail(props: Props) {
  const [data, setData] = React.useState<SavedRow|null>();
  const [propertyID, setPropertyID] = React.useState<string>(props.property_id);
  const [street, setStreet] = React.useState<string>("");
  const [cityStateZip, setCityStateZip] = React.useState<string>("");
  const [beds, setBeds] = React.useState<number | null>(null);
  const [baths, setBaths] = React.useState<number | null>(null);
  const [squareFeet, setSquareFeet] = React.useState<string | null>(null);
  const [prettyPrice, setPrettyPrice] = React.useState<string>("");
  const [listingKey, setListingKey] = React.useState<string>("");
  const [mlsStatus, setMlsStatus] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [image, setImage] = React.useState<PropertyImage | null>(null);
  const [propertyType, setPropertyType] = React.useState<string | null>(null);
  const [propertySubType, setPropertySubType] = React.useState<string | null>(
    null
  );
  const [id, setId] = React.useState<string>("");
  const [mediaLength, setMediaLength] = React.useState<number>(1);
  const [unitNumber, setUnitNumber] = React.useState<string | null>(null);
  const [selected, setSelected] = React.useState<boolean>(false);
  const [api,_] = React.useState<PropertyAPI>(new PropertyAPI());

  function updateCurrentImage(id: string, image: string) {
    const interval = window.setInterval(() => {
      const ele = document.getElementById(id);
      if (ele) {
        ele.style.backgroundImage = `url('${image}')`;
        window.clearInterval(interval);
      }
    }, 80);
  }
  React.useEffect(() => {
    setPropertyID(props.property_id);
    (async () => {
      setData(await api.get_property_by_source(props.property_id,props.source));
    })();
    if (!data){
      setError("Unable to find the listing you were looking for.");
    }
    setError(null);
  },[]);
  React.useEffect(() => {
    dd({ propertyID, error });
    if(!data){
      console.warn('data is null');
      return;
    }
    let media_length: number = 0;
    if (Array.isArray(data.Media)) {
      media_length = data.Media.length;
    } else {
      media_length = 0;
    }
    setMediaLength(media_length);

    const thumb_id: string = `prop-thumbnail-${props.property_id}`;
    setId(thumb_id);
    if (media_length > 0) {
      let image: PropertyImage | null = null;
      for (const media of data.Media) {
        try {
          if (Number(media.Order) === 0) {
            image = toS3Image(media.MediaURL, media.Order, props.source);
            setImage(image);
            break;
          }
        } catch (err) {}
      }
      if (image === null) {
        for (const media of data.Media) {
          try {
            setImage(toS3Image(media.MediaURL, media.Order, props.source));
            break;
          } catch (err) {}
        }
      }
      if (image) {
        updateCurrentImage(thumb_id, image.thumb.toString());
      }
    } else {
      updateCurrentImage(thumb_id, EMPTY_PROFILE_IMAGE);
    }
    if (typeof data.ListingKey !== "undefined") {
      if (String(data.ListingKey).match(/^KEY/)) {
        setListingKey(String(data.ListingKey).replace(/^KEY/, ""));
      } else {
        setListingKey(data.ListingKey);
      }
    }
    if (typeof data.MlsStatus !== "undefined") {
      setMlsStatus(data.MlsStatus);
    }
    const sqft: string = formatDecimalNumber(data.LotSizeSquareFeet);
    if (sqft === "-1") {
      setSquareFeet(null);
    } else {
      setSquareFeet(sqft);
    }
    if (
      typeof data.BathroomsFull === "undefined" ||
      Number(data.BathroomsFull) === 0
    ) {
      setBaths(null);
    } else {
      setBaths(data.BathroomsFull);
    }
    let half_baths: number = 0;
    if (
      typeof data.BathroomsHalf !== "undefined" ||
      Number(data.BathroomsHalf) > 0
    ) {
      half_baths = Number(data.BathroomsHalf);
    }
    if (
      typeof data.BedroomsTotal === "undefined" ||
      Number(data.BedroomsTotal) === 0
    ) {
      setBeds(null);
    } else {
      let baths: number = Number(data.BedroomsTotal);
      if (half_baths) {
        baths += half_baths;
      }
      setBeds(baths);
    }
    if(String(data.BathroomsFull).match(/\.00$/)){
      setBaths(Math.floor(data.BathroomsFull));
    }
    let compiled_street: string[] = [];
    if (
      typeof data.StreetNumber !== "undefined" &&
      String(data.StreetNumber) !== "undefined"
    ) {
      compiled_street.push(String(data.StreetNumber));
    }
    if (
      typeof data?.StreetName !== "undefined" &&
      String(data.StreetName) !== "undefined"
    ) {
      compiled_street.push(String(data.StreetName));
    }
    if (
      typeof data?.StreetSuffix !== "undefined" &&
      String(data.StreetSuffix) !== "undefined"
    ) {
      compiled_street.push(String(data.StreetSuffix));
    }
    setStreet(compiled_street.join(" "));
    let compiled_state: string[] = [];
    if (
      typeof data.PostalCity !== "undefined" &&
      String(data.PostalCity) !== "undefined"
    ) {
      compiled_state.push(processPostalCity(String(data.PostalCity)));
    }
    if (
      typeof data.StateOrProvince !== "undefined" &&
      String(data.StateOrProvince) !== "undefined"
    ) {
      compiled_state.push(String(data.StateOrProvince));
    }
    if (
      typeof data.PostalCode !== "undefined" &&
      String(data.PostalCode) !== "undefined"
    ) {
      compiled_state.push(String(data.PostalCode));
    }
    setCityStateZip(compiled_state.join(" "));
    setPrettyPrice(formatPrice(data.ListPrice));
    setPropertyType(data.PropertyType);
    setPropertySubType(data.PropertySubType);
    let unit_number: string | null = null;
    if (typeof data.UnitNumber !== "undefined" && data.UnitNumber !== null) {
      unit_number = data.UnitNumber;
    }
    setUnitNumber(unit_number);
  }, [data, propertyID, error]);
  function toggleSelect(e: SyntheticEvent) {
    e.preventDefault();
    const btn: HTMLButtonElement = e.target as HTMLButtonElement;
    const property_id: string = props.property_id;
    const value: boolean = !selected;
    btn.dataset["state"] = value ? "on" : "off";
    setSelected(value);
    if (value && global.lombardo.selected.indexOf(property_id) === -1) {
      global.lombardo.selected.push(property_id);
      return;
    }
    global.selected = global.lombardo.selected.filter(
      (pid: string) =>
        String(pid).toLowerCase() !== String(property_id).toLowerCase()
    );
  }
  return (
    <div className="PropertyThumbnail">
      {props.show_share_property_icons && (
        <div className="thumb-select-property-wrapper">
          <button
            className={
              "thumb-select-me " + (selected ? "thumb-select-me-selected" : "thumb-select-me-unselected")
            }
            data-thumbnailproperty={props.property_id}
            data-state={selected ? "on" : "off"}
            onClick={(e: any) => {
              toggleSelect(e);
              hideShareableLink();
            }}
          >
            {selected && <CheckboxSVG />}
            <span className="tsm-unchecked-wrapper">
            {!selected && <UnCheckboxSVG />}
            </span>
            Share This Property
          </button>
        </div>
      )}
      <div
        className="PropertyThumbnail"
        onClick={() => {
          const url: URL = new URL(window.location.href);
          url.searchParams.set("backDisplayMode", props.display_mode);
          url.searchParams.set("sortMode", props.sort_mode);
          url.searchParams.set("displayMode", "property");
          url.searchParams.set("listing", `KEY${listingKey}`);
          url.searchParams.set("source", props.source);
          if (Array.isArray(props.remove_from_url)) {
            for (const param of props.remove_from_url) {
              url.searchParams.delete(param);
            }
          }
          window.location.href = url.toString();
        }}
      >
        <div className="image-container" id={id}>
          {mediaLength > 0 && image && image.thumb && (
            <img
              src={image.thumb.toString()}
              width="250"
              className="property-thumbnail-img"
            />
          )}
          {mediaLength === 0 && (
            <img
              src={EMPTY_PROFILE_IMAGE}
              width="250"
              className="property-thumbnail-img"
            />
          )}
        </div>
        <div className="thumb-second-portion">
          <div className="thumb-line for-sale-line">
            {mlsStatus === "Active" && (
              <b className="for-sale-decorator">For Sale</b>
            )}
            {mlsStatus === "Pending" && (
              <b className="for-sale-decorator">Under Contract</b>
            )}
            {mlsStatus === "Sold" && <b className="sold-decorator">Sold</b>}
          </div>
          <div className="thumb-line">
            <span className="thumb-price">{prettyPrice}</span>
          </div>
          {propertySubType && (
            <div className="thumb-line">
              <span className="thumb-property-type thumb-font-fix-01">
                {Array.isArray(propertySubType) && (propertySubType.join(','))}
                {Array.isArray(propertySubType) === false && (propertySubType)}
              </span>
            </div>
          )}
          {!propertySubType && (
            <div className="thumb-line">
              <span className="thumb-property-type thumb-font-fix">
                {propertyType}
              </span>
            </div>
          )}
          <div className="thumb-line">
            <span className="thumb-street thumb-font-fix">{street}</span>
            {unitNumber !== null && (
              <span className="thumb-street thumb-font-fix">
                {" "}
                {presentUnitNumber(unitNumber)}
              </span>
            )}
          </div>
          <div className="thumb-line">
            <span className="thumb-city-state-zip thumb-font-fix">
              {cityStateZip}
            </span>
          </div>
          <div className="thumb-line">
            <span className="thumb-dimensions thumb-font-fix">
              <ul>
                {beds !== null && <li>{beds}bd</li>}
                {baths !== null && <li>{baths}ba</li>}
                {squareFeet !== null && Number(squareFeet) > 0 && <li>{squareFeet} sqft</li>}
              </ul>
            </span>
          </div>
          <div className="thumb-line">
            <span className="thumb-listing-key thumb-font-fix">
              MLS #{listingKey}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PropertyThumbnail;
